import { render } from "./PortSkalaton.vue?vue&type=template&id=5876b887"
const script = {}

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__